import classnames from 'classnames';

import { CURRENCY_CONFIGS } from '../constants';
import { type CurrencyKey } from '../types';
import styles from './CurrencyToggle.module.scss';

interface CurrencyToggleProps {
  value: CurrencyKey;
  onChange: (currency: CurrencyKey) => void;
}

const CURRENCIES: CurrencyKey[] = ['usd', 'gbp', 'eur'];

export default function CurrencyToggle({ value, onChange }: CurrencyToggleProps) {
  return (
    <div className={styles.toggle} role="radiogroup" aria-label="Currency selection">
      {CURRENCIES.map((key) => (
        <button
          key={key}
          type="button"
          role="radio"
          aria-checked={value === key}
          className={classnames(styles.option, value === key && styles.active)}
          onClick={() => onChange(key)}
        >
          {CURRENCY_CONFIGS[key].symbol}
        </button>
      ))}
    </div>
  );
}
